import { ICommonSettings } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigBucketUploadSettings } from "./app-settings-config-bucket-upload";

export interface IConfigBucketUploadInputState {
  showModal: boolean;
  editingBucketUploadId: string;
}

export interface IConfigBucketUploadInputProps {
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigBucketUploadInput extends PureComponent<
  IConfigBucketUploadInputProps,
  IConfigBucketUploadInputState
> {
  formInputName = ["apiConfig", "bucketUploadSettingsId"];

  constructor(props: IConfigBucketUploadInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingBucketUploadId: ""
    };
  }

  openModal = () => {
    this.setState({ showModal: true, editingBucketUploadId: "" });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  setEditingSetting = (id: string) => {
    this.setState({ editingBucketUploadId: id, showModal: true });
  };

  render() {
    const options = this.props.commonSettings.bucketUploadSettings ?? [];
    return (
      <>
        <ConfigBucketUploadSettings
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingBucketUploadId={this.state.editingBucketUploadId}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
        <div style={{ marginTop: 16 }}>
          <ConfigSettingSelect
            label="Configuration"
            formInputName={this.formInputName}
            options={options}
            tooltipContentKey=""
            onAddNew={this.openModal}
            onEdit={this.setEditingSetting}
            dropdownTestId="appSettingsBucketUploadDropdown"
            addNewTestId="appSettingsBucketUploadAddNewButton"
            editTestId="appSettingsBucketUploadEditButton"
          />
        </div>
      </>
    );
  }
}
